import React from 'react';
import { toast } from 'react-toastify';
import ToastMessage from './ToastMessage';

export interface CustomMessage {
  message: string;
  avatar?: string;
}

export const addSuccessToast = (success: CustomMessage): void => {
  toast.success(<ToastMessage message={success.message} />, {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: true,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: 'success-toast',
  });
};

export const addErrorToast = (error: CustomMessage): void => {
  toast.error(<ToastMessage message={error.message} />, {
    position: 'top-center',
    autoClose: 5000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: true,
    progress: undefined,
    className: 'error-toast',
  });
};

export const addInfoOrganizationToast = (info: CustomMessage): void => {
  toast.info(<ToastMessage message={info.message} avatar={info.avatar} />, {
    position: 'top-center',
    autoClose: 3000,
    hideProgressBar: false,
    closeOnClick: true,
    pauseOnHover: true,
    draggable: false,
    progress: undefined,
    className: 'info-organization-toast',
  });
};
